import type { DateTime } from "luxon";
import type { ConnectedBookingData } from "../../Booking-Form/typings/connected-bookingData";

/**
 * Open payload for the Dashboard2 colleague workplace floor dialog (#1572).
 * Date is a calendar day; highlight is the user’s desk when they already booked.
 */
export type ColleagueWorkplaceFloorOpenArgs = {
  /** Calendar day to load (user-local `yyyy-MM-dd`). */
  date: string;
  /** Workplace inventory to highlight when the user already has a desk that day. */
  highlightInventoryId?: number;
  /** Physical location to load; favorite / booking-that-day site. */
  locationInventoryId?: number;
  /** Display name for the location control above the floor chips. */
  locationName?: string;
};

/**
 * Dialog session state after open — date/time drive availability refetch.
 */
export type ColleagueWorkplaceFloorSession = ColleagueWorkplaceFloorOpenArgs & {
  open: boolean;
  startTime: string;
  endTime: string;
};

/** Floor chip shown above the Pixi canvas. */
export type ColleagueFloorChip = {
  id: number;
  name: string;
  colleagueCount: number;
};

export type ColleagueSearchOption = ConnectedBookingData;

export type ColleagueWorkplaceFloorTimeContext = {
  date: DateTime;
  startTime: string;
  endTime: string;
};

/**
 * What a workplace click does on the colleague floor canvas (#1572 v0.2).
 */
export enum ColleagueDeskClickKind {
  /** Free desk: nested book confirm. */
  BOOK = "book",
  /** Occupied or partial: calendar booking(s) for that desk. */
  OCCUPANCY = "occupancy",
  /** Not interactive (forbidden, disabled, missing id). */
  NONE = "none"
}
